/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  event?: string;
  preventDefault?: boolean;
  node?: 'div' | 'span';
}

const StopPropagation: FC<Props> = ({
  children,
  node: Node = 'div',
  preventDefault,
  event = 'onClick',
  ...props
}: Props) => {
  const callback = (e: MouseEvent | KeyboardEvent) => {
    if (preventDefault) e.preventDefault();
    e.stopPropagation();
  };
  const events: Record<string, typeof callback> = {};
  event.split(',').forEach((ev) => {
    events[ev.trim()] = callback;
  });

  return <Node {...{ ...events, ...props }}>{children}</Node>;
};

StopPropagation.defaultProps = {
  event: 'onClick',
  preventDefault: false,
  node: 'div',
};

export default StopPropagation;
